export interface NewsDate {
  year: number;
  month: number;
  day: number;
  fullDateString: string;
  daysSinceStart: number;
}

export interface AttackTypeStat {
  attacksMade: number;
  gains: number;
  attacksSuffered: number;
  gainsSuffered: number;
}

export interface AttacksByProvince {
  provinceName: string;
  attacksMade: number;
  attacksSuffered: number;
  acresChanged: number;
  uniques: number;
}

export interface KingdomAttacksByProvince {
  kingdomReference: string;
  attacksByProvinces: AttacksByProvince[];
  totalAcresChanged: number;
  totalAttacksMade: number;
  totalAttacksSuffered: number;
}

export interface Highlight {
  name: string;
  gains: number;
}

export interface KingdomNews {
  startDate: NewsDate;
  endDate: NewsDate;
  numberOfDays: number;
  parseString: string;
  dragonsCompleted: number;
  ritualsCompleted: number;
  ritualsStarted: number;
  enemyDragonsStarted: number;
  dragonsStarted: number;
  dragonsReceived: number;
  dragonsKilled: number;
  attacksMade: number;
  attacksSuffered: number;
  acresGain: number;
  acresLoss: number;
  tradMarches: AttackTypeStat;
  ambushes: AttackTypeStat;
  conquests: AttackTypeStat;
  razes: AttackTypeStat;
  learns: AttackTypeStat;
  massacres: AttackTypeStat;
  plunders: AttackTypeStat;
  failedAttacks: AttackTypeStat;
  kingdomAttacksByProvince: KingdomAttacksByProvince;
  enemyKdsAndProvinceList: KingdomAttacksByProvince[];
  chartData: any;
  biggestLandGain: Highlight;
  biggestLandLoss: Highlight;
  biggestAmbushGain: Highlight;
  biggestAmbushLoss: Highlight;
  mostBouncesMade: Highlight;
  mostBouncesReceived: Highlight;
}

export interface DictionaryStringInt {
  [key: string]: number;
}

export interface Loss {
  Name: string;
  amount: number;
}

export interface ProvinceEvent {
  date: NewsDate;
  attacker: any;
  newsType: NewsType;
  losses: Loss[];
  spellDuration: number;
  spellType: SpellType;
}

export interface ProvinceNews {
  startDate: NewsDate;
  endDate: NewsDate;
  numberOfDays: number;
  parseString: string;
  groupedLosses: DictionaryStringInt;
  events: ProvinceEvent[];
  meteorStrikes: DictionaryStringInt;
  propAttacks: DictionaryStringInt;
  enemyMages: string;
  enemyThieves: string;
}

export enum NewsType {
  newAcres = 1,
  moneyTick = 2,
  newScientist = 3,
  thieves = 4,
  tradMarch = 5,
  plunder = 6,
  massacre = 7,
  learn = 8,
  sorcery = 9,
  meteorStrike = 10,
  fireballStrike = 11,
  landLust = 12,
  aid = 13,
  dragon = 14,
  propaganda = 15,
  arson = 16,
  riots = 17,
  bribeGenerals = 18,
}

export enum SpellType {
  undefined = 0,
  greed = 1,
  meteors = 2,
  pitfalls = 3,
  landlust = 4,
  illuminate = 5,
  blizzards = 6,
  protection = 7,
}
